import { GzAntimalwareOnDemandScanTasksFormWebComponent } from './component/GzAntimalwareOnDemandScanTasksFormWebComponent';

export { GzAntimalwareOnDemandScanTasksFormWebComponent };
